import { cn } from '@wellesley/ui'
import { FC } from 'react'
import { ExternalLinks } from '@wellesley/router'
import InternalLinks from './../Markdown/InternalLinks'
import useHightlightCode from '../Markdown/hooks/useHightlightCode'

type MarkdownHtmlPreviewProps = {
  htmlString: string
  className?: string
}

export const MarkdownHtmlPreview: FC<MarkdownHtmlPreviewProps> = ({
  htmlString,
  className,
}) => {
  useHightlightCode(htmlString)

  return (
    <InternalLinks>
      <ExternalLinks>
        <div
          dangerouslySetInnerHTML={{ __html: htmlString }}
          className={cn('markdown', className)}
        />
      </ExternalLinks>
    </InternalLinks>
  )
}
